// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__ZdG6T","box":"WorkspacesBox_box__3fV9r","node":"WorkspacesBox_node__27Eyl"};